import React from 'react';
import { empresaData, contactoData } from '../data/mock';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1c1b] py-14">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Logo & Description */}
          <div className="lg:col-span-2 flex items-center gap-6">
            <img
              src={empresaData.logoBlanco}
              alt="Micro-Bat Logo"
              className="h-20 w-auto flex-shrink-0"
            />
            <p className="text-gray-400 max-w-md leading-relaxed">
              Soluciones industriales de precisión en fijación, control y mecanizado según estándares IQNet y AENOR.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-5">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Phone size={16} className="text-[#f4a261]" />
                <a href={`tel:${contactoData.telefono.replace(/\s/g, '')}`}>
                  {contactoData.telefono}
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Mail size={16} className="text-[#f4a261]" />
                <a href={`mailto:${contactoData.email}`}>
                  {contactoData.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={16} className="text-[#f4a261] flex-shrink-0 mt-1" />
                <span>
                  {contactoData.direccion}<br />
                  {contactoData.codigoPostal}
                </span>
              </li>
            </ul>
          </div>

          {/* Certificates */}
          <div>
            <h4 className="text-white font-semibold mb-5">Certificaciones</h4>
            <div className="flex items-center gap-5">
              {empresaData.certificados.map((cert) => (
                <img
                  key={cert.nombre}
                  src={cert.imagen}
                  alt={cert.nombre}
                  className="h-16 w-auto object-contain"
                />
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col items-center gap-4 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Micro-Bat S.L. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a 
              href="/Politica-de-calidad.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-white transition-colors"
            >
              Política de calidad
            </a>
            <span className="text-gray-700">|</span>
            <Link 
              to="/politica-privacidad"
              className="text-gray-500 text-sm hover:text-white transition-colors"
            >
              Política de privacidad
            </Link>
            <span className="text-gray-700">|</span>
            <Link 
              to="/aviso-legal"
              className="text-gray-500 text-sm hover:text-white transition-colors"
            >
              Aviso legal
            </Link>
            <span className="text-gray-700">|</span>
            <Link 
              to="/politica-cookies"
              className="text-gray-500 text-sm hover:text-white transition-colors"
            >
              Política de cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
